import {
  AuthRepository,
  UserRepository,
  UserRepositoryMerged,
} from 'lc-repository'

export const useLcServiceAuth = async () => {
  const { $lcRepositories } = useNuxtApp()

  const { authBuild } = await import('lc-services/modules/auth/authBuild')

  const { controller: authController, presenter: authPresenter } = authBuild(
    AuthRepository($lcRepositories.httpClient),
    UserRepository($lcRepositories.httpClient).auth,
    UserRepositoryMerged($lcRepositories.httpClient),
  )

  return {
    authController,
    authPresenter,
  }
}
